import React from 'react'
import {Skeleton} from 'primereact/skeleton'

export default function StudentCardSkeleton() {
  return (
    <div className='d-flex mb-8'>
      <Skeleton shape='circle' size='3rem' className='me-2'></Skeleton>
      <div className='mt-2' style={{flex: '1'}}>
        <Skeleton width='75%' className='mb-4'></Skeleton>
        <Skeleton width='100%' className='mb-2'></Skeleton>
        <Skeleton width='100%'></Skeleton>
      </div>
    </div>
  )
}
